module.exports = __webpack_public_path__ + "img/glasbreak-sensor-lg.938b2e38.svg";